<template>
  <div class="Exportjr5">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn type="button" @click="exportexceljr2(tokenexport, exportthn,exportbln,exportps,paparnegeriexport)" color="blue white white--text">
            <span class="material-icons">file_download</span>
            {{ $t("muatturun") }} {{ $t("jr5") }}
          </v-btn> -->
<!-- 
          <v-btn type="button" color="blue white white--text" @click="updateDataJR5()"> 
                SIMPAN
            </v-btn>

              &nbsp; -->

           <download-excel
              :data="papardatajr5"
              type="csv"
              name="jr5.xls"
              >

              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("jr5") }}
              </v-btn>


            </download-excel>


      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatajr5"
          height="500"
          fixed-header
        >

        <!-- <template v-slot:item.subINCS01="{ item }">
          {{totalINCS01(item)}}
        </template>

        <template v-slot:item.INCS02="{ item }">
          {{totalINCS02(item)}}
        </template>

        <template v-slot:item.INCS03="{ item }">
          {{totalINCS03(item)}}
        </template>

        <template v-slot:item.INCS05="{ item }">
          {{totalINCS05(item)}}
        </template>

        <template v-slot:item.INCS06="{ item }">
          {{totalINCS06(item)}}
        </template>

        <template v-slot:item.INCS07="{ item }">
          {{totalINCS07(item)}}
        </template>

        <template v-slot:item.INCS08="{ item }">
          {{totalINCS08(item)}}
        </template>

        <template v-slot:item.INCS10="{ item }">
          {{totalINCS10(item)}}
        </template> -->


        <!-- <template v-slot:item.INCS21="{ item }">
          {{totalINCS21(item)}}
        </template>

        <template v-slot:item.INCS22="{ item }">
          {{totalINCS22(item)}}
        </template> -->

          


        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
export default {
  Name: "Exportjr5",
  setup() {},
  props: ["papardatajr5", "exportthn", "exportbln", "exportps", "paparnegeriexport"],
  // mounted() {
  //   //console.log(this.papardatajr5)
  //   for(var i=0; i < this.papardatajr5.length; i++){
  //     this.totalINCS01(this.papardatajr5[i])
  //     this.totalINCS02(this.papardatajr5[i])
  //     this.totalINCS03(this.papardatajr5[i])
  //     this.totalINCS05(this.papardatajr5[i])
  //     this.totalINCS06(this.papardatajr5[i])
  //     this.totalINCS07(this.papardatajr5[i])
  //     this.totalINCS08(this.papardatajr5[i])
  //     this.totalINCS10(this.papardatajr5[i])
  //     //this.totalHK2INCS21A(this.papardatajr5[i])
  //     this.totalINCS21NA(this.papardatajr5[i])
  //     this.totalINCS21(this.papardatajr5[i])


  //   }
  // },
  data: () => ({
    tokenexport: window.localStorage.getItem('tokenexport'),
    databatch: "",
    headers: [
      { text: "HID", value: "HID",sortable: false},
      { text: "BNO", value: "BNO",sortable: false},
      { text: "Pusingan", value: "Pusingan",sortable: false},
      { text: "S", value: "S",sortable: false},
      { text: "NG", value: "NG",sortable: false},
      { text: "DP", value: "DP",sortable: false},
      { text: "DB", value: "DB",sortable: false},
      { text: "BP", value: "BP",sortable: false},
      { text: "ST", value: "ST",sortable: false},
      { text: "NOTK", value: "NOTK",sortable: false},
      { text: "NOIR", value: "NOIR",sortable: false},
      { text: "BULAN", value: "Bulan",sortable: false},
      { text: "TAHUN", value: "Tahun",sortable: false},

      { text: "NAMA", value: "Nama",sortable: false},
      { text: "PKIR", value: "PKIR",sortable: false},
      { text: "NOAIR", value: "NOAIR",sortable: false},
      { text: "J", value: "J",sortable: false},
      { text: "TK", value: "TK",sortable: false},
      { text: "U", value: "U",sortable: false},
      { text: "KET", value: "KET",sortable: false},
      { text: "KW", value: "KW",sortable: false},
      { text: "NOIC", value: "NOIC",sortable: false},
      { text: "RS", value: "RES",sortable: false},
      { text: "TP", value: "TP",sortable: false},
      { text: "OKU", value: "OKU",sortable: false},
      { text: "POKU", value: "POKU",sortable: false},
      { text: "PS", value: "Ps",sortable: false},
      { text: "STS", value: "STS",sortable: false},
      { text: "PT", value: "PT",sortable: false},
      { text: "SJ", value: "SJ",sortable: false},

      { text: "TA", value: "TA",sortable: false},
      { text: "M", value: "M",sortable: false},
      { text: "PP", value: "PP",sortable: false},
      // { text: "KC", value: "KC",sortable: false},
      // { text: "PC", value: "PC",sortable: false},
      { text: "PK", value: "PK",sortable: false},
      { text: "PN", value: "PN",sortable: false},
      { text: "KL", value: "S19i",sortable: false},

      { text: "INCS11", value: "INCS11",sortable: false},
      { text: "INCS12", value: "INCS12",sortable: false},
      { text: "INCS13", value: "INCS13",sortable: false},
      { text: "INCS14", value: "INCS14",sortable: false},
      { text: "INCS15", value: "INCS15",sortable: false},
      { text: "INCS16", value: "INCS16",sortable: false},
      { text: "INCS17", value: "INCS17",sortable: false},
      { text: "INCS18", value: "INCS18",sortable: false},
      { text: "INCS19_a", value: "INCS19_a",sortable: false},
      { text: "INCS19_b", value: "INCS19_b",sortable: false},
      { text: "INCS19_c", value: "INCS19_c",sortable: false},
      { text: "INCS19", value: "INCS19",sortable: false},
      { text: "INCS01", value: "INCS01",sortable: false},
      { text: "INCS01_hh", value: "INCS01_hh",sortable: false},

      { text: "HK2INCS21A_i", value: "HK2INCS21A_i",sortable: false},
      { text: "HK2INCS21A_ii", value: "HK2INCS21A_ii",sortable: false},
      { text: "HK2INCS21A_iii", value: "HK2INCS21A_iii",sortable: false},
      { text: "HK2INCS21a", value: "HK2INCS21a",sortable: false},
      { text: "HK3INCS21A_i", value: "HK3INCS21A_i",sortable: false},
      { text: "HK3INCS21A_ii", value: "HK3INCS21A_ii",sortable: false},
      { text: "HK3INCS21A_iii", value: "HK3INCS21A_iii",sortable: false},
      { text: "HK3INCS21a", value: "HK3INCS21a",sortable: false},
      { text: "HK2INCS21a", value: "totalHK2INCS21a",sortable: false},
      { text: "HK4INCS21B_i", value: "HK4INCS21B_i",sortable: false},
      { text: "HK4INCS21B_ii", value: "HK4INCS21B_ii",sortable: false},
      { text: "HK4INCS21B_iii", value: "HK4INCS21B_iii",sortable: false},
      { text: "HK4INCS21b", value: "HK4INCS21b",sortable: false},
      { text: "HK4INCS21c", value: "HK4INCS21c",sortable: false},
      { text: "HK5INCS21D_i", value: "HK5INCS21D_i",sortable: false},
      { text: "HK5INCS21D_ii", value: "HK5INCS21D_ii",sortable: false},
      { text: "HK5INCS21D_iii", value: "HK5INCS21D_iii",sortable: false},
      { text: "HK5INCS21d", value: "HK5INCS21d",sortable: false},
      { text: "HK6INCS21E_i", value: "HK6INCS21E_i",sortable: false},
      { text: "HK6INCS21E_ii", value: "HK6INCS21E_ii",sortable: false},
      { text: "HK6INCS21E_iii", value: "HK6INCS21E_iii",sortable: false},
      { text: "HK6INCS21e", value: "HK6INCS21e",sortable: false},

      { text: "INCS21NA", value: "INCS21NA",sortable: false},
      { text: "INCS21KS", value: "INCS21KS",sortable: false},
      { text: "INCS21", value: "INCS21",sortable: false},
      { text: "INCS22", value: "INCS22",sortable: false},
      { text: "INCS23", value: "INCS23",sortable: false},
      { text: "INCS24", value: "INCS24",sortable: false},
      { text: "INCS02", value: "INCS02",sortable: false},
      { text: "INCS02_hh", value: "INCS02_hh",sortable: false},

      { text: "INCS31", value: "INCS31",sortable: false},
      { text: "INCS32a", value: "INCS32a",sortable: false},
      { text: "INCS32b", value: "INCS32b",sortable: false},
      { text: "INCS32", value: "INCS32",sortable: false},
      { text: "INCS33", value: "INCS33",sortable: false},
      { text: "INCS34", value: "INCS34",sortable: false},
      { text: "INCS03", value: "INCS03",sortable: false},
      { text: "INCS03_hh", value: "INCS03_hh",sortable: false},

      { text: "INCS41a", value: "INCS41a",sortable: false},
      { text: "INCS41b", value: "INCS41b",sortable: false},
      { text: "INCS41", value: "INCS41",sortable: false},
      { text: "INCS42", value: "INCS42",sortable: false},
      { text: "INCS43", value: "INCS43",sortable: false},
      { text: "INCS44", value: "INCS44",sortable: false},

      { text: "INCS45a", value: "INCS45a",sortable: false},
      { text: "INCS45b", value: "INCS45b",sortable: false},
      { text: "INCS45c", value: "INCS45c",sortable: false},
      { text: "INCS45d", value: "INCS45d",sortable: false},
      { text: "INCS45e", value: "INCS45e",sortable: false},
      { text: "INCS45f", value: "INCS45f",sortable: false},
      { text: "INCS45g", value: "INCS45g",sortable: false},
      { text: "INCS45h", value: "INCS45h",sortable: false},
      { text: "INCS45i", value: "INCS45i",sortable: false},
      { text: "INCS45j", value: "INCS45j",sortable: false},
      { text: "INCS45k", value: "INCS45k",sortable: false},
      { text: "INCS45l", value: "INCS45l",sortable: false},
      { text: "INCS45m", value: "INCS45m",sortable: false},
      { text: "INCS45", value: "INCS45",sortable: false},

      { text: "INCS46a_i", value: "INCS46a_i",sortable: false},
      { text: "INCS46a_ii", value: "INCS46a_ii",sortable: false},
      { text: "INCS46a", value: "INCS46a",sortable: false},
      { text: "INCS46b", value: "INCS46b",sortable: false},
      { text: "INCS46c", value: "INCS46c",sortable: false},
      { text: "INCS46d_i", value: "INCS46d_i",sortable: false},
      { text: "INCS46d_ii", value: "INCS46d_ii",sortable: false},
      { text: "INCS46d", value: "INCS46d",sortable: false},
      { text: "INCS46e", value: "INCS46e",sortable: false},
      { text: "INCS46f", value: "INCS46f",sortable: false},
      { text: "INCS46", value: "INCS46",sortable: false},
      { text: "INCS05", value: "INCS05",sortable: false},
      { text: "INCS05_hh", value: "INCS05_hh",sortable: false},


      { text: "TP61_a", value: "TP61_a",sortable: false},
      { text: "TP61_b", value: "TP61_b",sortable: false},
      { text: "TP61_c", value: "TP61_c",sortable: false},
      { text: "TP61", value: "TP61",sortable: false},
      { text: "TP62", value: "TP62",sortable: false},
      { text: "TP63", value: "TP63",sortable: false},
      { text: "TP64_a", value: "TP64_a",sortable: false},
      { text: "TP64_b", value: "TP64_b",sortable: false},
      { text: "TP64_c", value: "TP64_c",sortable: false},
      { text: "TP64", value: "TP64",sortable: false},
      { text: "TP65", value: "TP65",sortable: false},
      { text: "TP66", value: "TP66",sortable: false},
      { text: "TP67", value: "TP67",sortable: false},
      { text: "TP73A", value: "TP73A",sortable: false},
      { text: "TP68", value: "TP68",sortable: false},
      { text: "TP69", value: "TP69",sortable: false},
      { text: "TP70", value: "TP70",sortable: false},
      { text: "TP71", value: "TP71",sortable: false},
      { text: "TP72_a", value: "TP72_a",sortable: false},
      { text: "TP72_b", value: "TP72_b",sortable: false},
      { text: "TP72_c", value: "TP72_c",sortable: false},
      { text: "TP73B", value: "TP73B",sortable: false},
      { text: "TP73", value: "TP73",sortable: false},
      { text: "TP73_hh", value: "TP73_hh",sortable: false},
      { text: "TP74", value: "TP74",sortable: false},

      { text: "INCS06", value: "INCS06",sortable: false},
      { text: "INCS07", value: "INCS07",sortable: false},
      { text: "INCS08", value: "INCS08",sortable: false},
      { text: "INCS06_hh", value: "INCS06_hh",sortable: false},
      { text: "INCS07_hh", value: "INCS07_hh",sortable: false},
      { text: "INCS08_hh", value: "INCS08_hh",sortable: false},

      // { text: "INCS09a", value: "INCS09a",sortable: false},
      // { text: "INCS09b", value: "INCS09b",sortable: false},
      // { text: "INCS09c", value: "INCS09c",sortable: false},
      // { text: "INCS09d", value: "INCS09d",sortable: false},
      // { text: "INCS09e", value: "INCS09e",sortable: false},
      // { text: "INCS09", value: "INCS09",sortable: false},
      { text: "INCS09_hh", value: "INCS09_hh",sortable: false},
      
      { text: "INCS10_a", value: "INCS10_a",sortable: false},
      { text: "INCS10_b", value: "INCS10_b",sortable: false},
      { text: "INCS10_c", value: "INCS10_c",sortable: false},
      { text: "INCS10_d", value: "INCS10_d",sortable: false},
      { text: "INCS10_e", value: "INCS10_e",sortable: false},
      { text: "INCS10_f", value: "INCS10_f",sortable: false},
      { text: "INCS10_g", value: "INCS10_g",sortable: false},
      { text: "INCS10_h", value: "INCS10_h",sortable: false},
      { text: "INCS10", value: "INCS10",sortable: false},
      { text: "INCS10_hh", value: "INCS10_hh",sortable: false},

      // { text: "Lai", value: "Lai",sortable: false},
      // { text: "Laii", value: "Laii",sortable: false},
      // { text: "Lbi", value: "Lbi",sortable: false},
      // { text: "Lbii", value: "Lbii",sortable: false},
      // { text: "Lci", value: "Lci",sortable: false},
      // { text: "Lcii", value: "Lcii",sortable: false},
      // { text: "Ldi", value: "Ldi",sortable: false},
      // { text: "Ldii", value: "Ldii",sortable: false},
      // { text: "Lei", value: "Lei",sortable: false},
      // { text: "Leii", value: "Leii",sortable: false},
      // { text: "L01", value: "L01",sortable: false},
      // { text: "LMa", value: "LMa",sortable: false},
      // { text: "LMb", value: "LMb",sortable: false},
      // { text: "LMc", value: "LMc",sortable: false},
      // { text: "LMd", value: "LMd",sortable: false},
      // { text: "LMe", value: "LMe",sortable: false},

      { text: "S19i", value: "S19i",sortable: false},


    
    ],
  }),
  methods: {
    totalINCS01(rowData){
        var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        total = Number(total) + Number(rowData.INCS11) + Number(rowData.INCS12) + Number(rowData.INCS13) + Number(rowData.INCS14) + Number(rowData.INCS15) + Number(rowData.INCS16) + Number(rowData.INCS17) + Number(rowData.INCS18) + Number(rowData.INCS19);
        this.papardatajr5[indexItem]['INCS01'] = total;

        return total;
    },
    totalINCS01_hh(originalData, listOfDataSameHID){
        //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        for(var a=0; a < listOfDataSameHID.length; a++){
           total = Number(total) + Number(listOfDataSameHID[a].INCS11) + Number(listOfDataSameHID[a].INCS12) + Number(listOfDataSameHID[a].INCS13) + Number(listOfDataSameHID[a].INCS14) + Number(listOfDataSameHID[a].INCS15) + Number(listOfDataSameHID[a].INCS16) + Number(listOfDataSameHID[a].INCS17) + Number(listOfDataSameHID[a].INCS18) + Number(listOfDataSameHID[a].INCS19);
        }
       
        originalData['INCS01_hh'] = total;

        return total;
    },
    totalINCS02(rowData){

      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        total = Number(total) + Number(rowData.HK2INCS21a) + Number(rowData.HK3INCS21a) + 
                Number(rowData.HK4INCS21b) + Number(rowData.HK4INCS21c) + Number(rowData.HK5INCS21d) + 
                Number(rowData.HK6INCS21e) + Number(rowData.INCS21KS) + 
                Number(rowData.INCS22) + Number(rowData.INCS23) + Number(rowData.INCS24) ;
        this.papardatajr5[indexItem]['INCS02'] = total;

        return total;
    },
    totalINCS02_hh(originalData, listOfDataSameHID){

      //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        for(var a=0; a < listOfDataSameHID.length; a++){
          total = Number(total) + Number(listOfDataSameHID[a].HK2INCS21a) + Number(listOfDataSameHID[a].HK3INCS21a) + Number(listOfDataSameHID[a].HK4INCS21b) + 
                Number(listOfDataSameHID[a].HK4INCS21c) + Number(listOfDataSameHID[a].HK5INCS21d) + Number(listOfDataSameHID[a].HK6INCS21e) + Number(listOfDataSameHID[a].INCS21KS) + 
                Number(listOfDataSameHID[a].INCS22) + Number(listOfDataSameHID[a].INCS23) + Number(listOfDataSameHID[a].INCS24) ;
        }
       originalData['INCS02_hh'] = total;

        return total;
    },
    totalINCS03(rowData){

      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        total = Number(total) + Number(rowData.INCS31) + Number(rowData.INCS32a)+ Number(rowData.INCS32b) + Number(rowData.INCS33) + Number(rowData.INCS34) ;
        rowData['INCS03'] = total;
        return total;
    },
    totalINCS03_hh(originalData, listOfDataSameHID){

      //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        for(var a=0; a < listOfDataSameHID.length; a++){
          total = Number(total) + Number(listOfDataSameHID[a].INCS31) + Number(listOfDataSameHID[a].INCS32a)+ Number(listOfDataSameHID[a].INCS32b) + Number(listOfDataSameHID[a].INCS33) + Number(listOfDataSameHID[a].INCS34) ;
        }
        originalData['INCS03_hh'] = total;
        return total;
    },
    totalINCS05(rowData){

      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;

        total = Number(total) + Number(rowData.INCS41) + Number(rowData.INCS42) + Number(rowData.INCS43) + Number(rowData.INCS44) + Number(rowData.INCS45) + Number(rowData.INCS46) ;
        this.papardatajr5[indexItem]['INCS05'] = total;
        return total;
    },
    totalINCS05_hh(originalData, listOfDataSameHID){

      //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        for(var a=0; a < listOfDataSameHID.length; a++){
          total = Number(total) + Number(listOfDataSameHID[a].INCS41) + Number(listOfDataSameHID[a].INCS42) + Number(listOfDataSameHID[a].INCS43) + Number(listOfDataSameHID[a].INCS44) + Number(listOfDataSameHID[a].INCS45) + Number(listOfDataSameHID[a].INCS46) ;
        }
        originalData['INCS05_hh'] = total;
        return total;
    },
    totalTP73_hh(originalData, listOfDataSameHID){
        // console.log("TP73_hh: "+rowData)
      //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
      for(var a=0; a < listOfDataSameHID.length; a++){
       total = Number(total) + Number(listOfDataSameHID[a].TP73A) + Number(listOfDataSameHID[a].TP73B);
      }
        originalData['TP73_hh'] = total;
        return total;
    },
    totalINCS06(rowData){
      
      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        total = Number(total) + (Number(rowData.INCS41) + Number(rowData.INCS42)+ Number(rowData.INCS43) + Number(rowData.INCS44) + Number(rowData.INCS45) + Number(rowData.INCS46))- Number(rowData.TP73)  ;
        rowData['INCS06'] = total;

        return total;
    },
    totalINCS06_hh(originalData, listOfDataSameHID){
      
      //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
      for(var a=0; a < listOfDataSameHID.length; a++){
        total = Number(total) + (Number(listOfDataSameHID[a].INCS41) + Number(listOfDataSameHID[a].INCS42)+ Number(listOfDataSameHID[a].INCS43) + Number(listOfDataSameHID[a].INCS44) + Number(listOfDataSameHID[a].INCS45) + Number(listOfDataSameHID[a].INCS46)) - Number(listOfDataSameHID[a].TP73)  ;
      }
        originalData['INCS06_hh'] = total;

        return total;
    },
    totalINCS07(rowData){

      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        total = Number(total) + Number(rowData.INCS01) + Number(rowData.HK2INCS21a) + Number(rowData.HK3INCS21a) + Number(rowData.HK4INCS21b) + Number(rowData.HK4INCS21c) + Number(rowData.HK5INCS21d) + Number(rowData.HK6INCS21e) + Number(rowData.INCS21KS) + Number(rowData.INCS22) + Number(rowData.INCS23) + Number(rowData.INCS24) + Number(rowData.INCS31) + Number(rowData.INCS32a) + Number(rowData.INCS32b) + Number(rowData.INCS33) + Number(rowData.INCS34) + Number(rowData.INCS41) + Number(rowData.INCS42)+ Number(rowData.INCS43) + Number(rowData.INCS44) + Number(rowData.INCS45) + Number(rowData.INCS46) ;
        this.papardatajr5[indexItem]['INCS07'] = total;
        return total;
    },
    totalINCS07_hh(originalData, listOfDataSameHID){

      //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        for(var a=0; a < listOfDataSameHID.length; a++){
          // total = Number(total) + Number(listOfDataSameHID[a].INCS01) + Number(listOfDataSameHID[a].HK2INCS21a) + Number(listOfDataSameHID[a].HK3INCS21a) + Number(listOfDataSameHID[a].HK4INCS21b) + Number(listOfDataSameHID[a].HK4INCS21c) + Number(listOfDataSameHID[a].HK5INCS21d) + Number(listOfDataSameHID[a].HK6INCS21e) + Number(listOfDataSameHID[a].INCS21KS) + Number(listOfDataSameHID[a].INCS22) + Number(listOfDataSameHID[a].INCS23) + Number(listOfDataSameHID[a].INCS24) + Number(listOfDataSameHID[a].INCS31) + Number(listOfDataSameHID[a].INCS32) + Number(listOfDataSameHID[a].INCS33) + Number(listOfDataSameHID[a].INCS34) + Number(listOfDataSameHID[a].INCS41) + Number(listOfDataSameHID[a].INCS42)+ Number(listOfDataSameHID[a].INCS43) + Number(listOfDataSameHID[a].INCS44) + Number(listOfDataSameHID[a].INCS45) + Number(listOfDataSameHID[a].INCS46) ;
         total = Number(total) + Number(listOfDataSameHID[a].INCS01) + Number(listOfDataSameHID[a].HK2INCS21a) + Number(listOfDataSameHID[a].HK3INCS21a) + Number(listOfDataSameHID[a].HK4INCS21b) + Number(listOfDataSameHID[a].HK4INCS21c) + Number(listOfDataSameHID[a].HK5INCS21d) + Number(listOfDataSameHID[a].HK6INCS21e) + Number(listOfDataSameHID[a].INCS21KS) + Number(listOfDataSameHID[a].INCS22) + Number(listOfDataSameHID[a].INCS23) + Number(listOfDataSameHID[a].INCS24) + Number(listOfDataSameHID[a].INCS31) + Number(listOfDataSameHID[a].INCS32a) + Number(listOfDataSameHID[a].INCS32b) + Number(listOfDataSameHID[a].INCS33) + Number(listOfDataSameHID[a].INCS34) + Number(listOfDataSameHID[a].INCS41) + Number(listOfDataSameHID[a].INCS42)+ Number(listOfDataSameHID[a].INCS43) + Number(listOfDataSameHID[a].INCS44) + Number(listOfDataSameHID[a].INCS45) + Number(listOfDataSameHID[a].INCS46) ;
        }
        originalData['INCS07_hh'] = total;
        return total;
    },
    totalINCS08(rowData){
      //console.log(rowData);
      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        // total = Number(total) + Number(rowData.INCS01) + Number(rowData.INCS02) + Number(rowData.INCS03) + Number(rowData.INCS06) ;
        // total = Number(total) + Number(rowData.INCS01) + Number(rowData.INCS02)+ Number(rowData.INCS31) + Number(rowData.INCS32a)+ Number(rowData.INCS32b) + Number(rowData.INCS33) + Number(rowData.INCS34) + Number(rowData.INCS06);
        total = Number(total) + Number(rowData.INCS01) + Number(rowData.INCS02)+ 
        Number(rowData.INCS31) + Number(rowData.INCS32a)+ Number(rowData.INCS32b) + Number(rowData.INCS33) + Number(rowData.INCS34) + 
        ((Number(rowData.INCS41) + Number(rowData.INCS42) + Number(rowData.INCS43) + Number(rowData.INCS44) + Number(rowData.INCS45) + Number(rowData.INCS46)) - Number(rowData.TP73))
        
        this.papardatajr5[indexItem]['INCS08'] = total;
        return total;
    },
    totalINCS08_hh(originalData, listOfDataSameHID){
      //console.log(rowData);
      //var indexItem = this.papardatajr5.indexOf(rowData);
      var currentdata= listOfDataSameHID

        
        var total = 0;
        for(var j=0; j < currentdata.length; j++){
          //console.log("NOAIR: "+listOfDataSameHID[a].NOAIR+" total: "+total+" INCS01:"+listOfDataSameHID[a].INCS01+" INCS02:"+ listOfDataSameHID[a].INCS02 +" INCS03:"+ (Number(listOfDataSameHID[a].INCS31) + Number(listOfDataSameHID[a].INCS32a)+ Number(listOfDataSameHID[a].INCS32b) + Number(listOfDataSameHID[a].INCS33) + Number(listOfDataSameHID[a].INCS34))+" INCS06:"+ (Number(listOfDataSameHID[a].INCS05) - Number(listOfDataSameHID[a].TP73)))
          total = Number(total) + 
          //Number(currentdata[j].INCS01) + Number(currentdata[j].INCS02) + 
          Number(currentdata[j].INCS11) + Number(currentdata[j].INCS12) + Number(currentdata[j].INCS13) + Number(currentdata[j].INCS14) + Number(currentdata[j].INCS15) + Number(currentdata[j].INCS16) + Number(currentdata[j].INCS17) + Number(currentdata[j].INCS18) + Number(currentdata[j].INCS19)+ //incs01
          Number(currentdata[j].HK2INCS21a) + Number(currentdata[j].HK3INCS21a) + Number(currentdata[j].HK4INCS21b) + Number(currentdata[j].HK4INCS21c) + Number(currentdata[j].HK5INCS21d) + Number(currentdata[j].HK6INCS21e) + Number(currentdata[j].INCS21KS) + Number(currentdata[j].INCS22) + Number(currentdata[j].INCS23) + Number(currentdata[j].INCS24) + //incs02
          Number(currentdata[j].INCS31) + Number(currentdata[j].INCS32a) + Number(currentdata[j].INCS32b) + Number(currentdata[j].INCS33) + Number (currentdata[j].INCS34) +
          Number(currentdata[j].INCS41) + Number(currentdata[j].INCS42) + Number(currentdata[j].INCS43) + Number(currentdata[j].INCS44) + Number(currentdata[j].INCS45) + Number(currentdata[j].INCS46) - Number(currentdata[j].TP73) ;

        }

        originalData['INCS08_hh'] = total;

    },
    totalINCS10(rowData){

      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        total = Number(total) + Number(rowData.INCS10) ;
        this.papardatajr5[indexItem]['INCS10'] = total;
        return total;
    },
    totalINCS10_hh(originalData, listOfDataSameHID){

      //var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        for(var a=0; a < listOfDataSameHID.length; a++){
          total = Number(total) + Number(listOfDataSameHID[a].INCS10) ;
        }
        originalData['INCS10_hh'] = total;
        return total;
    },
    totalHK2INCS21A(rowData){
        // console.log("currow: "+rowData)
      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        total = Number(total) + Number(rowData.HK2INCS21a) + Number(rowData.HK3INCS21a) ;
        rowData.totalHK2INCS21A = total;
        
        return total;
    },
    totalINCS21NA(rowData){
      //  console.log("na");
      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        // total = Number(total) + Number(rowData.totalHK4INCS21b) + Number(rowData.totalHK4INCS21c) + Number(rowData.totalHK5INCS21d) + Number(rowData.totalHK6INCS21e) ;
        total = Number(total) + Number(rowData.HK4INCS21B_i) + Number(rowData.HK4INCS21B_ii) + Number(rowData.HK4INCS21B_iii) + Number(rowData.HK4INCS21c) + Number(rowData.HK5INCS21D_i) + Number(rowData.HK5INCS21D_ii) + Number(rowData.HK5INCS21D_iii)  + Number(rowData.HK6INCS21E_i) + Number(rowData.HK6INCS21E_ii) + Number(rowData.HK6INCS21E_iii) ;
        rowData.INCS21NA = total;
        
        return total;
    },

     totalINCS21(rowData){
        //  console.log("incs21");
      var indexItem = this.papardatajr5.indexOf(rowData);
        var total = 0;
        // total = Number(total) + Number(rowData.INCS10) ;
        total = Number(total) + Number(rowData.totalHK2INCS21A) + Number(rowData.HK4INCS21B_i) + Number(rowData.HK4INCS21B_ii)  + Number(rowData.HK4INCS21B_iii) + Number(rowData.HK4INCS21c) + Number(rowData.HK5INCS21D_i) + Number(rowData.HK5INCS21D_ii) + Number(rowData.HK5INCS21D_iii)  + Number(rowData.HK6INCS21E_i) + Number(rowData.HK6INCS21E_ii) + Number(rowData.HK6INCS21E_iii) + Number(rowData.INCS21KS) ;
        // this.papardatajr5[indexItem]['totalHK2INCS21A'] = total;
        rowData.INCS21 = total;
        
        return total;
    },
    // 

    // totalINCS21NA(rowData){

    //   var indexItem = this.papardatajr5.indexOf(rowData);
    //     var total = 0;
    //     total = Number(total) + Number(rowData.INCS10) ;
    //     this.papardatajr5[indexItem]['INCS10'] = total;
    //     return total;
    // },
    // totalINCS10(rowData){

    //   var indexItem = this.papardatajr5.indexOf(rowData);
    //     var total = 0;
    //     total = Number(total) + Number(rowData.INCS10) ;
    //     this.papardatajr5[indexItem]['INCS10'] = total;
    //     return total;
    // },




    // totalINCS21(rowData){
    //   if (rowData.INCS21===''){return 0}
    //   else {return rowData.INCS21}
    // },
    // totalINCS22(rowData){
    //   if (rowData.INCS22===''){return 0}
    //   else {return rowData.INCS22}
    // },
  
    async exportexceljr2(tokenexport, exportthn,exportbln,exportps,paparnegeriexport){
      try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/sec/checksession`,
            {
                tokenexportsess: window.localStorage.getItem('tokenexport')
            }
          )
          .then(result=>{
            //console.log(result.data.status)
            if(result.data.status){
              window.open(`${process.env.VUE_APP_API_URL}/JR5/exportjr5serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`, '_blank');
            }
          })
      } catch (error) {
        console.log(error)
      }
    },

    
  async updateDataJR5(){

       try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/fixData/fixINCSJR5`,
            {
                listData : this.papardatajr5

            }
          )
          .then(result=>{
              if(result.data.status){
                alert("Succesfully Updated!");
              }
            })
        } catch (error) {
          console.log(error)
        }

    }





  },

  
 
  watch:{
    async papardatajr5(){

      for(var i=0; i < this.papardatajr5.length; i++){
        await this.totalINCS01(this.papardatajr5[i])
        await this.totalINCS02(this.papardatajr5[i])
        await this.totalINCS03(this.papardatajr5[i])
        await this.totalINCS05(this.papardatajr5[i])
        await this.totalINCS06(this.papardatajr5[i])
        await this.totalINCS07(this.papardatajr5[i])
        await this.totalINCS08(this.papardatajr5[i])
        await this.totalINCS10(this.papardatajr5[i])
        await this.totalHK2INCS21A(this.papardatajr5[i])
        await this.totalINCS21NA(this.papardatajr5[i])
        await this.totalINCS21(this.papardatajr5[i])
        // this.totalINCS01_hh(this.papardatajr5[i])
        // this.totalINCS02_hh(this.papardatajr5[i])
        // this.totalINCS03_hh(this.papardatajr5[i])
        // this.totalINCS05_hh(this.papardatajr5[i])
        // this.totalINCS06_hh(this.papardatajr5[i])
        // this.totalINCS07_hh(this.papardatajr5[i])
        // this.totalINCS08_hh(this.papardatajr5[i])
        // this.totalINCS10_hh(this.papardatajr5[i])
        // this.totalTP73_hh(this.papardatajr5[i])

        //check if noair == 01
        if(this.papardatajr5[i].NOAIR == "01"){
          //if noair 01 find all other data that same HID as current HID
          var arr = [];
          var data = this.papardatajr5;
          var dataLength = this.papardatajr5.length;
          for(var x = 0; x < dataLength; x++){
            //if found then insert into array
            if(data[x].HID == this.papardatajr5[i].HID){
              arr.push(data[x])
            }
          }
          //call function to calculate hh and pass the array with all the HID
          await this.totalINCS01_hh(this.papardatajr5[i],arr)
          await this.totalINCS02_hh(this.papardatajr5[i],arr)
          await this.totalINCS03_hh(this.papardatajr5[i],arr)
          await this.totalINCS05_hh(this.papardatajr5[i],arr)
          await this.totalINCS06_hh(this.papardatajr5[i],arr)
          await this.totalINCS07_hh(this.papardatajr5[i],arr)
          await this.totalINCS08_hh(this.papardatajr5[i],arr)
          await this.totalINCS10_hh(this.papardatajr5[i],arr)
          await this.totalTP73_hh(this.papardatajr5[i],arr)

        }



      }

    }
    
  }
};
</script>